import React from 'react';
import { LogOut } from 'lucide-react';
import { useAuth } from '@/hooks';
import { ROLE_LABELS } from '@/utils/constants';
import { Button } from '@/components/common';

export const Header: React.FC = () => {
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
  };

  return (
    <header className="bg-dark-lighter border-b border-gray-700 sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src="/logo.png" alt="Logo" className="h-12 w-auto object-contain" />
            <div>
              <h1 className="text-xl font-bold text-primary">
                نظام إدارة مخزون البطاريات
              </h1>
              <p className="text-sm text-gray-400">
                Battery Inventory Management System
              </p>
            </div>
          </div>

          {user && (
            <div className="flex items-center gap-4">
              <div className="text-right">
                <p className="text-sm font-semibold text-white">{user.username}</p>
                <p className="text-xs text-gray-400">{ROLE_LABELS[user.role]}</p>
              </div>
              <Button
                variant="secondary"
                size="sm"
                onClick={handleLogout}
                className="gap-2"
              >
                <LogOut className="h-4 w-4" />
                تسجيل الخروج
              </Button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};
